<template>
  <div class="top-regions mb-4 pb-4"
       v-loading="geoLoading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="pt-4 px-4 pb-8 flex flex-row flex-no-wrap justify-between">
      <select name="country" v-model="value" id="" @change="setRegion">
        <option value="" disabled="disabled">Please select</option>
        <option v-for="item in options" :value="item.value">{{item.label}}</option>
      </select>
    </div>
    <div class="px-2 flex flex-row flex-no-wrap justify-between">
      <div class="state-list w-full h-full" v-if="topRegions.length > 0">
        <h5 class="text-white" v-for="region in topRegions">{{region.region}} -- {{region.sales}}</h5>
      </div>
      <div class="chart">
      </div>
    </div>
    <GChart
      :settings="settings"
      type="GeoChart"
      :data="chartData"
      :options="chartOptions"
      :events="chartEvents"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'top_regions',
  components: {
    GChart,
  },
  computed: {
    totalSalesByLocation() {
      return this.$store.getters['Dashboard/totalSalesByLocation'] || 0;
    },

    chartData() {
      return this.$store.getters['Dashboard/fetchTopRegions'];
    },

    outlets() {
      return this.$store.state.Dashboard.sales_location;
    },

    topRegions() {
      return this.$store.state.Dashboard.top_regions;
    },
    options() {
      return [
        {
          value: 'NG',
          label: 'Nigeria',
        },
      ];
    },
  },
  data() {
    return {
      geoLoading: true,
      value: '',
      settings: {
        packages: ['geochart'],
        mapsApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      },
      chartEvents: {
        ready: () => {
          this.geoLoading = false;
        },
        error: () => {
          this.geoLoading = true;
        },
        regionClick: (evt) => {
          this.$store.commit('Dashboard/setTopRegions', evt.region);
        },
      },
      chartOptions: {
        region: 'world',
        legend: 'none',
        backgroundColor: 'none',
        displayMode: 'marker',
        magnifyingGlass: {
          enable: true,
          zoomFactor: 7.5,
        },
        colorAxis: { minValue: 0, colors: ['#FF0000', '#00FF00'] },
      },
    };
  },
  methods: {
    async setRegion() {
      this.chartOptions.region = this.value;
      this.chartOptions.resolution = 'provinces';
      this.chartOptions.backgroundColor = 'none';
      this.geoLoading = true;
      await this.$store.dispatch('Dashboard/fetchDataForTopStates');
    },
  },
};
</script>

<style scoped lang="scss">
.top-regions {
  background-image: linear-gradient(to top, #47a62d, #94f587);
  /*height: 435px;*/
}

.state-list {
  /*flex: 0 1 29%*/
}

.chart {
  /*flex: 0 1 90%;*/
}
</style>
